const activeFeature = ( state=null, action ) => {
    switch(action.type){
        case "SET_ACTIVE_FEATURE":
            return action.featureKey;
        default:
            return state;
    }
};

export default activeFeature;



// WEBPACK FOOTER //
// ./src/reducers/active-feature.js